import { defineComponent as _defineComponent } from 'vue'
import { ref, defineAsyncComponent } from 'vue'
import { useConfirmWithPromise } from '@composables/useModalOpener'


export default /*#__PURE__*/_defineComponent({
  __name: 'Container',
  setup(__props, { expose: __expose }) {
  __expose();

const local = ref(null)
const componentExtactor = defineAsyncComponent(() => import(`@components/Modals/Wrapper`))

const save = ({ component }) => {
  local.value = component
}

const checkHandler = async (params, close) => {
  if (params?.reload) {
    window.location.reload()
  } else if (params?.promise && params?.info?.skipPromiseWhenClose) {
    params.promise(false)
    close()
  } else if (params?.info?.askForConfirmTitle) {
    const info = {
      title: params?.info?.askForConfirmTitle,
    }
    try {
      await useConfirmWithPromise(info)
      close()
    } catch (e) {
      console.error(e)
      console.clear()
    }
  } else {
    close()
  }
}


const __returned__ = { local, componentExtactor, save, checkHandler, ref, defineAsyncComponent, get useConfirmWithPromise() { return useConfirmWithPromise } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})